import Vue from 'vue';

Vue.config.devtools = true
const mutations = {
  setCurrentCart(state, payload) {
    state.currentCart = payload;
  },
  setMainProducts(state, payload) {
    state.mainProducts = payload;
  },
  setAddonProducts(state, payload) {
    state.addonProducts = payload;
  },
  setCardProducts(state, payload) {
    state.cardProducts = payload;
  },
  updateCartItem(state,payload){
    let product = payload.cartItem;
    let quantity = payload.quantity;
    let currentIndex = state.currentCart.items.findIndex(x => x == product);
    if(currentIndex > -1 && quantity > 0){
      state.currentCart.items[currentIndex].quantity = quantity;
    }
    else if(currentIndex > -1 && quantity == 0){
      state.currentCart.items.splice(currentIndex, 1);
    }
  },
  setFeeProduct(state,payload){
    state.feeProduct = payload;
  },
};

export default mutations;
